import {AsyncStatusesEnum} from '../../../../../libs/shared/helpers/src/types/asyncStatuses';
import {AppAction} from '../../../appActions';
import {ContactCardPanelActionsEnum} from './contactCardPanelActions';
import {ContactCardPanelState} from './contactCardPanelState';

/*
 * Reducer.
 */

export function contactCardPanelReducer(
  state: ContactCardPanelState,
  action: AppAction,
): ContactCardPanelState {
  switch (action.type) {
    case ContactCardPanelActionsEnum.FETCH_CONTACT_CARD_DATA:
      return {
        ...state,
        status: AsyncStatusesEnum.LOADING,
        selectedCardId: undefined,
        conversationIds: undefined,
        conversationStatus: undefined,
      };
    case ContactCardPanelActionsEnum.FETCH_CONTACT_CARD_DATA_COMPLETED:
      return {
        ...state,
        status: AsyncStatusesEnum.LOADED,
        selectedCardId: action.payload.selectedCardId,
      };
    case ContactCardPanelActionsEnum.FETCH_CONTACT_CARD_ACCOUNT:
      return {
        ...state,
        accountStatus: AsyncStatusesEnum.LOADING,
      };
    case ContactCardPanelActionsEnum.FETCH_CONTACT_CARD_ACCOUNT_COMPLETED:
      return {
        ...state,
        accountStatus: AsyncStatusesEnum.LOADED,
      };
    case ContactCardPanelActionsEnum.SELECTED_CARD_UPDATED:
      return {
        ...state,
        selectedCardId: action.payload.selectedCardId,
      };

    case ContactCardPanelActionsEnum.FETCH_CONTACT_CARD_CONVERSATIONS:
      return {
        ...state,
        conversationIds: undefined,
        conversationStatus: AsyncStatusesEnum.LOADING,
      };
    case ContactCardPanelActionsEnum.FETCH_CONTACT_CARD_CONVERSATIONS_COMPLETED:
      return {
        ...state,
        conversationIds: [...action.payload.conversationIds],
        conversationStatus: AsyncStatusesEnum.LOADED,
      };
    case ContactCardPanelActionsEnum.FETCH_CONTACT_CARD_CONVERSATIONS_FAILED:
      return {
        ...state,
        conversationStatus: AsyncStatusesEnum.FAILED,
      };

    default:
      return state;
  }
}
